import JobsList from ".";

export const jobsListRoutes = () => [
  {
    path: "/user/jobs",
    component: JobsList,
    layout: "user",
    routeType: "user",
    title: "User Jobs Management",
  },
];